import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { formatBlogDate } from '../../../utils/blogDate';

const BlogSideBar = () => {
  const { id } = useParams();
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Fetch all blogs for sidebar
    axios.get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/blog.php`)
      .then(res => {
        if (Array.isArray(res.data)) {
          setRecentBlogs(res.data.slice(0, 5));
          const uniqueCategories = [...new Set(res.data.map(b => (b.blog_keyword || '').split(',')[0]?.trim()))];
          setCategories(uniqueCategories.filter(Boolean));
        }
      })
      .catch(err => {
        console.error('Error fetching blog sidebar:', err);
      });
  }, [id]);


  return (
<>
          <div className="mb-5">
            <div className="sidebar-title">Categories</div>
            <div className="list-group">
              {categories.map((cat, index) => (
                <div className="category-item" key={index}>{cat}</div>
              ))}
            </div>
          </div>

          <div>
            <div className="sidebar-title">Recent Posts</div>
            {recentBlogs.map((item, idx) => (
              <div key={idx} className="d-flex recent-post-wrapper">
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}${item.blog_img}`}
                  alt={item.blog_name}
                  className="recent-thumbnail"
                />
                <div>
                <Link to={`/blog/${item.blog_id}`} className="recent-text">{item.blog_name}</Link>
                  <div className="recent-date">
                    {formatBlogDate(item.updated_on || item.created_at)}
                  </div>
            
                </div>
              </div>
            ))}
          </div>
</>
 
  );
};

export default BlogSideBar;